export default "__VITE_ASSET__CH4YV0Pp__"